(() => {
  const ROOT_STICKY_VAR = '--sticky-announcement-bar-is-sticky';
  const ROOT_HEIGHT_VAR = '--sticky-announcement-bar-height';

  const clearStickyVars = () => {
    document.documentElement.style.setProperty(ROOT_STICKY_VAR, '0');
    document.documentElement.style.setProperty(ROOT_HEIGHT_VAR, '0px');
  };

  const refresh = (el) => {
    const section = el.closest('.shopify-section');
    if (!section) return;

    const isSticky = el.dataset.sticky === 'true';
    document.documentElement.style.setProperty(ROOT_STICKY_VAR, isSticky ? '1' : '0');
    document.documentElement.style.setProperty(
      ROOT_HEIGHT_VAR,
      `${Math.round(section.getBoundingClientRect().height)}px`
    );
  };

  const init = (el) => {
    if (el.dataset.stickyAnnouncementBarReady === 'true') return;
    el.dataset.stickyAnnouncementBarReady = 'true';

    const section = el.closest('.shopify-section');
    if (!section) return;

    refresh(el);

    if (window.ResizeObserver) {
      new ResizeObserver(() => refresh(el)).observe(section);
    }
  };

  const boot = () => {
    document.querySelectorAll('[data-sticky-announcement-bar]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-sticky-announcement-bar]').forEach(init);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.matches?.('.shopify-section--sticky-announcement-bar')) {
      clearStickyVars();
    }
  });
})();
